import { useEffect, useState } from 'react';

import './index.css';
import './App.css';
import CreateSiteAdmin from './CreateSiteAdmin';
import LoginPanel from './LoginPanel';
import { hasSupabaseEnv, supabase } from './supabaseClient';
import copy from './i18n/sv.json';

function getInitialTheme() {
  const savedTheme = window.localStorage.getItem('create-site-theme');

  if (savedTheme === 'light' || savedTheme === 'dark') {
    return savedTheme;
  }

  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

function getThemeToggleLabel(theme) {
  return theme === 'dark' ? copy.app.themeToggleLight : copy.app.themeToggleDark;
}

function App() {
  const [theme, setTheme] = useState(getInitialTheme);
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    window.localStorage.setItem('create-site-theme', theme);
  }, [theme]);

  useEffect(() => {
    if (!hasSupabaseEnv || !supabase) {
      setLoading(false);
      return undefined;
    }

    let isMounted = true;

    supabase.auth.getSession().then(({ data }) => {
      if (!isMounted) {
        return;
      }

      setSession(data.session || null);
      setLoading(false);
    });

    const {
      data: { subscription }
    } = supabase.auth.onAuthStateChange((_event, nextSession) => {
      setSession(nextSession || null);
      setLoading(false);
    });

    return () => {
      isMounted = false;
      subscription.unsubscribe();
    };
  }, []);

  async function handleSignOut() {
    await supabase.auth.signOut();
  }

  function handleToggleTheme() {
    setTheme((currentTheme) => (currentTheme === 'light' ? 'dark' : 'light'));
  }

  if (loading) {
    return (
      <div className="auth-page">
        <div className="theme-toggle-wrap">
          <button type="button" className="button button--secondary theme-toggle" onClick={handleToggleTheme}>
            {getThemeToggleLabel(theme)}
          </button>
        </div>
        <div className="auth-card auth-card--compact">
          <p className="auth-description">{copy.app.loadingSession}</p>
        </div>
      </div>
    );
  }

  if (!session) {
    return <LoginPanel theme={theme} onToggleTheme={handleToggleTheme} />;
  }

  return (
    <div className="App">
      <div className="session-bar">
        <div>
          <p className="session-bar__label">{copy.app.loggedInAs}</p>
          <p className="session-bar__value">{session.user.email}</p>
        </div>
        <div className="session-bar__actions">
          <button type="button" className="button button--secondary theme-toggle" onClick={handleToggleTheme}>
            {getThemeToggleLabel(theme)}
          </button>
          <button type="button" className="button button--secondary" onClick={handleSignOut}>
            {copy.app.signOut}
          </button>
        </div>
      </div>
      <CreateSiteAdmin accessToken={session.access_token} />
    </div>
  );
}

export default App;
